// Mirrors the server's cleanup so an untouched list never triggers a save.
export function cleanExternalIds(values: string[]): string[] {
	return [...new Set(values.map((value) => value.trim()).filter(Boolean))]
}

export function externalIdsChanged(saved: string[], edited: string[]) {
	const next = cleanExternalIds(edited)
	return (
		next.length !== saved.length ||
		next.some((value, index) => value !== saved[index])
	)
}
